import { styled, SxProps, Theme, Typography, useTheme } from "@mui/material";
import { Checkbox, MarkedText } from "@volt_developers/components";

import { FILTERS_TEST_IDS } from "../../constants";

import type { MouseEvent } from "react";

interface SearchResultProps {
  isChecked: boolean;
  searchText: string;
  text: string;
  "data-testid"?: string;
  indeterminate?: boolean;
  onClick?: () => void;
  sxMarked?: SxProps<Theme>;
}

export function SearchResultLabel({
  text,
  searchText,
  isChecked,
  sxMarked,
  indeterminate,
  onClick,
  "data-testid": dataTestId,
}: SearchResultProps) {
  const theme = useTheme();

  const handleOnClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      event.stopPropagation();
      onClick();
    }
  };

  return (
    <Wrapper variant="buttonMedium">
      <Checkbox
        checked={isChecked}
        data-testid={dataTestId && FILTERS_TEST_IDS.getCheckbox(dataTestId)}
        indeterminate={indeterminate}
        tabIndex={-1}
        onClick={handleOnClick}
      />
      <StyledMarkedText
        sx={sxMarked}
        text={text}
        textToMark={searchText}
        markedStyle={{
          color: theme.palette.text.highlight,
        }}
      />
    </Wrapper>
  );
}

const Wrapper = styled(Typography)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1.5),
  alignItems: "center",
  letterSpacing: 0,
}));

const StyledMarkedText = styled(MarkedText)({});
